import { render, staticRenderFns } from "./Asignarsede.vue?vue&type=template&id=fef12ece"
import script from "./Asignarsede.vue?vue&type=script&lang=js"
export * from "./Asignarsede.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports